import { createContext, useContext, useState, useEffect, useRef, useMemo } from 'react';
import Commons from '../../../helpers/Commons';

export const SearchSelectContext = createContext({});
export const useSearchSelectContext = () => useContext(SearchSelectContext);

const SearchResultsWithItemSelection = WrappedComponent => {
    const ComponentWrapper = (props) => {
        const [itemSelected, setItemSelected] = useState([]);
        const [prevCount, setPrevCount] = useState(0);
        const [isActivityMenuActive, setIsActivityMenuActive] = useState(true);
        const [selectedHistoricCounter, setSelectedHistoricCounter] = useState(0);

        const prevLocation = useRef(props.location);

        useEffect(() => {
            // Mimic componentDidUpdate for location prop
            if (!Commons.isEqual(props.location, prevLocation.current)) {
                setIsActivityMenuActive(true);
            }
            prevLocation.current = props.location;
        });

        const toggleSelection = (itemId) => {
            setItemSelected((prev) => {
                if (prev.includes(itemId)) {
                    const newSelected = prev.filter(id => id !== itemId);
                    setPrevCount(prev.length);
                    return newSelected;
                }
                return [...prev, itemId];
            });
        };

        const incrementSelectedHistoricCount = () => {
            setSelectedHistoricCounter(count => count + 1);
        };

        const decrementSelectedHistoricCount = () => {
            setSelectedHistoricCounter(count => count - 1);
        };

        const isAllSelectedHistoric = () => {
            return itemSelected.length === selectedHistoricCounter;
        };

        const clearSelection = () => {
            setItemSelected([]);
            setSelectedHistoricCounter(0);
        };

        const itemSelection = (items) => {
            setItemSelected(prev => Array.from(new Set([...prev, ...items])));
        };

        const toggleActivityMenu = () => {
            setIsActivityMenuActive(active => !active);
        };

        const handleHistoricCount = (isHistoricalPropertySelected) => {
            if (isHistoricalPropertySelected) {
                decrementSelectedHistoricCount();
            } else {
                incrementSelectedHistoricCount();
            }
        };

        const contextValue = useMemo(() => ({
            itemSelected,
            prevCount,
            isActivityMenuActive,
            toggleSelection,
            toggleActivityMenu,
            itemSelection,
            clearSelection,
            isAllSelectedHistoric,
            handleHistoricCount,
        }), [
            itemSelected,
            prevCount,
            isActivityMenuActive,
            isAllSelectedHistoric,
        ]);

        return (
            <SearchSelectContext.Provider value={contextValue}>
                <WrappedComponent
                    {...props}
                    clearSelection={clearSelection}
                    itemSelection={itemSelection}
                />
            </SearchSelectContext.Provider>
        );
    };
    ComponentWrapper.displayName = 'SearchResultsWithItemSelection';
    return ComponentWrapper;
};

export default SearchResultsWithItemSelection;
